import { Prism } from '@mantine/prism';
import { createStyles } from '@mantine/core';
import dracula from 'prism-react-renderer/themes/dracula';

const useCodeBlockStyle = createStyles((_, { padding }) => ({
  codeBlock: {
    '*': {
      fontFamily:
        'SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace',
    },

    borderRadius: '0.75rem',

    'div > pre': {
      padding: padding || '18px 9px',
      fontSize: 14,
    },
  },
}));


const CodeBlock = ({
  code,
  language,
  shadow = false,
  padding = '',
  ...props
}) => {
  const { classes } = useCodeBlockStyle({ padding });
  return (
    <Prism
      className={classes.codeBlock}
      copyLabel={'코드 복사'}
      copiedLabel={'복사 완료'}
      colorScheme={'dark'}
      language={language}
      getPrismTheme={() => dracula}
      style={{
        boxShadow: !shadow ? '5px 5px 10px rgb(0 0 0 / 25%)' : null,
      }}
      {...props}
    >
      {code}
    </Prism>
  );
};

export default CodeBlock;
